// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"703":"20408a83","724":"d4e2416d","928":"9b8a369d"}[chunkId] + ".chunk.css";
};